import Axios from 'axios';
import header from './auth/header'

const API_URL = process.env.API_URL + '/api/v3';

class KycFunder {
	updateProfileKYC(data) {
		return Axios.patch(API_URL + '/kyc-funder/update-profile', data, { headers: header() });
	}
	registerKYC() {
		return Axios.post(API_URL + '/kyc-funder/register', null, { headers: header() });
	}
	getUrlWebviewRegisterKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-register', data, { headers: header() });
	}
	redirectRegisterKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/redirect-register', data, { headers: header() });
	}
	getUrlWebviewPenautanKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-penautan', data, { headers: header() });
	}
	redirectPenautanKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/redirect-penautan', data, { headers: header() });
	}
    getUrlWebviewGantiMFA(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-ganti-mfa', data, { headers: header() });
    }
    getUrlWebviewGantiSignature(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-ganti-signature', data, { headers: header() });
    }
	revokeCertificate(data) {
		return Axios.post(API_URL + '/kyc-funder/revoke-certificate', data, { headers: header() });
	}
	registerReEnroll() {
		return Axios.post(API_URL + '/kyc-funder/re-enroll/register', null, { headers: header() });
	}
	getUrlWebviewRegisterReEnroll(data) {
		return Axios.post(API_URL + '/kyc-funder/re-enroll/webview-register', data, { headers: header() });
	}
	redirectRegisterReEnroll(data) {
		return Axios.post(API_URL + '/kyc-funder/re-enroll/redirect-register', data, { headers: header() });
	}
	getUrlWebviewPenautanReEnroll(data) {
		return Axios.post(API_URL + '/kyc-funder/re-enroll/webview-penautan', data, { headers: header() });
	}
	redirectPenautanReEnroll(data) {
		return Axios.post(API_URL + '/kyc-funder/re-enroll/redirect-penautan', data, { headers: header() });
	}
}

export default new KycFunder();


// WEBPACK FOOTER //
// ./src/api/kycfunder.js